import axios from 'axios'
import ramses from '../api/ramses'

async function getUserInfo(hash) {
  try {
    const resposta = await fetch('https://api.ipify.org?format=json');
    const ipData = await resposta.json();
    
    const userAgent = navigator.userAgent
    const language = navigator.language
    const screenWidth = window.screen.width
    const screenHeight = window.screen.height
    const colorDepth = window.screen.colorDepth
    const javaEnabled = navigator.javaEnabled()
    const timeZoneOffset = Math.abs(new Date().getTimezoneOffset() / 60);

    const isMobile = /Mobi|Android/i.test(userAgent)
    const isTablet = /Tablet|iPad/i.test(userAgent)
    const isTV = /SmartTV|TV|HbbTV/i.test(userAgent)
    const deviceType = isTV ? 'TV' : isTablet ? 'TABLET' : isMobile ? 'MOBILE' : 'BROWSER'

    const browser =
      userAgent.includes('Firefox') ? 'Firefox' :
      userAgent.includes('Edg') ? 'Edge' :
      userAgent.includes('Chrome') ? 'Chrome' :
      userAgent.includes('Safari') ? 'Safari' :
      userAgent.includes('Opera') || userAgent.includes('OPR') ? 'Opera' : 'Desconhecido'


    const BaseUrl = process.env.VUE_APP_URL
    const threeDSecure = {
      redirectUrlSuccess:  `${BaseUrl}link-pagamento/1/${hash}`, 
      redirectUrlFailure: `${BaseUrl}link-pagamento/1/${hash}?s=err`,  
      userAgent,
      ipAddress: ipData.ip,
      device: {
        colorDepth,
        deviceType,
        language: language.toUpperCase(),
        javaEnabled,
        screenHeight,
        screenWidth,
        timeZoneOffset: timeZoneOffset.toString()
      }
    }

    return {
      threeDSecure,
      browser,
      platform: navigator.platform,
      language,
      screen: { width: screenWidth, height: screenHeight },
      deviceType,
      userAgent,
      ipData
    }

  } catch (error) {
    console.error('Erro ao obter informações do usuário:', error)
    return null
  }
}

async function getPostalCode(postalCode) {
  try {
    const postalCodeWithoutSymbols = postalCode.replace(/-/g, '');
    const url = `/ws/postal-code/${postalCodeWithoutSymbols}`;
    const response = await ramses.get(
      url,
      { headers: {'Api-key': process.env.VUE_APP_API_KEY}}
    );

    return response
  } catch ({ response }) {
    return response
  }
}

export {
  getUserInfo,
  getPostalCode,
}

// async function getIp() {
//   try {
//     return await axios.get('https://ipapi.co/json/')
//   } catch ({ response }) {
//     return response
//   }
// }
